import * as React from 'react';
import { observer, inject } from 'mobx-react';
import { GroupStore, SecretariatStore } from '../../store';
import { Group } from '../../store/models/Group';
import { RouteComponentProps } from 'react-router-dom';
import { TLCode } from '../../common/enums';
import { Instance } from 'mobx-state-tree';
import GroupForm from './GroupForm';
import withTranslate, { WithTranslateProps } from '../common/WithTranslate';
import MainSectionLayout from '../layout/MainSectionLayout';
import { Card, Tab, Tabs } from '@blueprintjs/core';
import styled from '@emotion/styled';
import { css } from 'emotion';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const CardStyle = css({
  height: '100%',
  '& .ant-card-body': {
    height: '100%',
  },
});

interface GroupPageProps extends RouteComponentProps<{ id: string }> {
  GroupStore?: Instance<typeof GroupStore>;
  SecretariatStore?: Instance<typeof SecretariatStore>;
}

interface GroupPageState {
  isLoading: boolean;
  group?: Instance<typeof Group>;
  groupList?: Array<Instance<typeof Group>>;
}

@inject('GroupStore', 'SecretariatStore')
@observer
class GroupPage extends React.Component<GroupPageProps & WithTranslateProps, GroupPageState> {
  state = {
    isLoading: false,
  } as GroupPageState;

  _isMounted = false;

  async fetchData() {
    const { GroupStore } = this.props;
    const groupId = parseInt(this.props.match.params.id, 10);
    this._isMounted && this.setState({ isLoading: true });
    if (groupId > 0) {
      if (!this.props.SecretariatStore!.isListLoaded()) await this.props.SecretariatStore!.loadList();
      const group = GroupStore!.getById(groupId);
      const groupList = GroupStore!.dataList;
      this._isMounted && this.setState({ group, groupList });
    }
    this._isMounted && this.setState({ isLoading: false });
  }

  async componentDidMount() {
    this._isMounted = true;
    await this.fetchData();
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  componentDidUpdate(prevProps: GroupPageProps, prevState: GroupPageState) {
    if (prevProps.match.params.id !== this.props.match.params.id) {
      this.fetchData();
    }
  }

  renderTitle = () => {
    const group = this.state.group;
    return group !== undefined ? (
      <h1>
        {this.props.translate(TLCode.GROUP_Edit)}&nbsp;
        {group!.name}
      </h1>
    ) : (
      <h1>{this.props.translate(TLCode.GROUP_Add)}</h1>
    );
  };

  save = async (data: any) => {
    this._isMounted && this.setState({ isLoading: true });
    await this.props.GroupStore!.saveGroup(data);
    this._isMounted && this.setState({ isLoading: false });
  };

  public render() {
    const { isLoading, group, groupList } = this.state;
    return (
      <MainSectionLayout isLoading={isLoading} renderHeader={this.renderTitle}>
        <Container>
          <Card className={CardStyle.toString()}>
            <Tabs id="main" selectedTabId="profile">
              <Tab
                id="profile"
                title="Détails"
                panel={
                  <GroupForm
                    group={group}
                    groupList={groupList}
                    save={this.save}
                    secretariatList={this.props.SecretariatStore!.dataList}
                  />
                }
              />
            </Tabs>
          </Card>
        </Container>
      </MainSectionLayout>
    );
  }
}

export default withTranslate(GroupPage);
